import React, { Component, useEffect,useRef } from 'react';
import { Modal, Upload,Popconfirm, message, Divider,  Table, Form, Icon, Input, Button, Select, Card, Radio, Spin , Row, Col} from 'antd';
import client from '../../feathers';
import requireAuth  from "../requireAuth";
import Layout  from "../layout";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import Info  from "../common/info";
import moment from 'moment';


//--------------------------------------------------------------------
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const _ = require('lodash');
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset:4 },
};

const tablebody = {
    padding : "4px 4px",
};

const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2
})

const todaydate = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear()

var balanceAmount = 0
var ledgerId = ''
var StatementTotal = [];
var today8 = moment().format('DD MMM YYYY')
//-------------------------------------------------------------------------------
class ComponentToPrint extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataSource:[],
            jmb:{},
            loading:false,
            invoiceAndItems:[],
            propertyunit:[],
            CurrentPagination:1,
            totalRecord:0,
            balanceAmount: 0,
            unitAddress:'',
            setting:'',
        }
      }

    componentWillMount(){

        this.setState({loading:true});

        //get JMB INFO
        client.authenticate()
        .then((res)=>{
          return client.service('settings').find({
            query: {
                propertyId:sessionStorage.getItem('companyId'),
             }
          })
      })
      .then((res)=>{
        this.setState({
          setting:res.data[0],})

            return client.service('jmbs').find({
              query: {
                  $populate:'propertyId',
                  propertyId:sessionStorage.getItem('companyId'),
                  status:'ACTIVE',
                  $sort: {
                    createdAt: -1
                  },
                  $limit:1
               }
            })
        })
        .then((res)=>{
            this.setState({
              jmb:res.data[0],
              jmbAddress : (res.data[0].headerLine1?res.data[0].headerLine1.toUpperCase()+',':'') + ' ' +
                           (res.data[0].headerLine2?res.data[0].headerLine2.toUpperCase()+',':'') + ' ' +
                           (res.data[0].headerLine3?res.data[0].headerLine3.toUpperCase()+',':'') + ' ' +
                           (res.data[0].headerLine4?res.data[0].headerLine4.toUpperCase():'')
            });

            client.service('properties').find({
             query:{
               _id:sessionStorage.getItem('companyId')
             }
           })
         .then((res)=>{

           this.setState({
             unitAddress: (res.data[0].addressLineA?res.data[0].addressLineA.toUpperCase()+',':'') + ' ' +
                          (res.data[0].addressLineB?res.data[0].addressLineB.toUpperCase()+',':'') + ' ' +
                          (res.data[0].addressLineC?res.data[0].addressLineC.toUpperCase()+',':'') + ' ' +
                          (res.data[0].postCode?res.data[0].postCode+',':'') + ' ' +
                          (res.data[0].country?res.data[0].country.toUpperCase():'') + ' '
           });
         })

        })
        .then((res)=>{
          return axios.get(`${client.io.io.uri}remindeLetterInqAll`,{
            params:{
              companyId:sessionStorage.getItem('companyId'),
               filterbyAmount : this.props.filterAmount?this.props.filterAmount:0
            },
            headers: {
              'Authorization': client.settings.storage.storage['feathers-jwt']
            }
          })
        })
        .then((res)=>{

          if (res.data.result.length <=0){
            message.error("No record found.")
          }
          
          res.data.result = _.orderBy(res.data.result,['referenceId'],['asc'])

            this.setState({
              dataSource:res.data,
              loading:false
            });
        })
        .catch((err)=>{
          console.log(err);
        });




    }

//----------------------------------------------------------------------

//----------------------------------------------------------------------
    componentDidUpdate(){

    }



//----------------------------------------------------------------------
    _renderTable = () => {

        const dataSource    = this.state.dataSource;
        const loading       = this.state.loading;
        const jmb           = this.state.jmb;
        let table           = [];
        var balanceAmount = 0;
        var ledgerId = '';

        // Outer loop to create parent
        let recordCount = dataSource.result?dataSource.result.length:0

        if (recordCount>0){
        for (let i = 0; i < dataSource.result.length; i++) {

                {balanceAmount=0;}


                table.push([
                  <div>
                  <Row>
                    <Col span={24} align="right">
                      <p><span className='customBold'>P.U. [A] 107</span></p>

                    </Col>
                  </Row>
                    <Row>
                      <Col span={24} align="middle">
                        <p><span className='customBold'>STRATA MANAGEMENT ACT 2013</span></p>
                        <br/>
                        <p><span className='customBold'>STRATA MANAGEMENT [MAINTENANCE AND MANAGEMENT]</span></p>
                        <p><span className='customBold'>REGULATIONS 2015</span></p>
                        <br/>
                        <p><span className='customBold'>FORM 20</span></p>
                        <p><span>(Regulation) 31</span></p>
                        <p><span className='customBold'>NOTICE TO DEMAND PAYMENT OF SUM DUE BY PROPRIETOR</span></p>
                      </Col>
                    </Row>

                    <br/>

                    <Row gutter={24}>
                    <Col offset={1} span={4}><span>TO</span></Col>
                    <Col span={1}><span>:</span></Col>
                    <Col span={18}>
                    <span>
                    {dataSource.result[i].owner?dataSource.result[i].owner.name:''}
                    </span>
                    </Col>
                    </Row>

                    <Row gutter={24}>
                    <Col  offset={6} span={18}>
                    <TextArea readOnly style={{fontWeight: 650,fontSize: '1em',resize: 'none',padding: 0,width: '300px',height: '10 0px',border: 'none'}} value={dataSource.result[i].owner?dataSource.result[i].owner.mailingAddress:''} rows={4} />
                    </Col>
                    </Row>

                    <Row gutter={24}>
                    <Col offset={1} span={4}><span>PARCEL/UNIT</span></Col>
                    <Col span={1}><span>:</span></Col>
                    <Col span={18}><span style={{'paddingleft':'0px'}}>{dataSource.result[i].referenceId?dataSource.result[i].referenceId+','+this.state.unitAddress:''} </span></Col>
                    </Row>

                    <Row gutter={24}>
                    <Col offset={1} span={4}><span>Name of *management corporation</span></Col>
                    <Col span={1}><span>:</span></Col>
                    <Col span={18}><span style={{'paddingleft':'0px'}}>{this.state.jmbAddress?this.state.jmbAddress:''} </span></Col>
                    </Row>

                    <br/>
                    <Row gutter={24}>
                    <Col offset={1}>
                    <p><span className='customBold2'>WHEREAS</span> you have committed a breach of the provisions of the Strata Management Act 2013(“the Act”) by- *failing to pay to the management corporation under subsection 52(4) or 60(4) or 60(5) or 61(4) or 61(5) of the Act:</p>
                    <p>*(a) Charges in the sum of <span className='customBold2'>RM {parseFloat(dataSource.result[i].othersDueAmt).toFixed(2)}</span></p>
                    <p>*(b) contribution to the sinking fund in the sum of <span className='customBold2'>RM {parseFloat(dataSource.result[i].sinkingfund).toFixed(2)}</span></p>
                    <br/>
                    <p>*failing to fully discharge your liability in respect of the amount of money lawfully incurred by the *management corporation / *subsidiary management corporation in the course of exercise of its powers or functions, or its duties or obligations, which according to subsection 59(3) of the Act and/or subsection 77(1) of the Act which is guaranteed by you as a proprietor, in the sum of <span className='customBold2'>RM {parseFloat(dataSource.result[i].totalDueAmt).toFixed(2)}</span>;</p>
                    <p><span className='customBold2'>AND WHEREAS</span> the said sum of <span className='customBold2'>RM {parseFloat(dataSource.result[i].totalDueAmt).toFixed(2)}</span> has become recoverable from you by virtue of the provisions of the Act mentioned above;</p>
                    <br/>
                    <p>We as *management corporation / *subsidiary management corporation, by virtue of the powers conferred by subsection 78(1) of the Act hereby demand payment of the sum due within the period of <span className='customBold2'>14 day(s)</span> (Note 1) from the date of service of this notice, failing which we may file a summons or claim in a court of competent jurisdiction or in the Strata Management Tribunal for recovery of the said sum, or as an alternative, resort to recovery under section 79 of the Act for attachment of movable property.</p>
                    <br/>
                    <p><span className='customBold2'>AND TAKE FURTHER NOTICE</span> that any proprietor who, without reasonable excuse, fails to comply with this notice commits an offence under subsection 78(3) of the Act and shall, on conviction, be liable to a fine not exceeding five thousand ringgit or to imprisonment for a term not exceeding three years or to both, and in the case of a continuing offence, to a further fine not exceeding fifty ringgit for every day or part thereof during which the offence continues after conviction.</p>
                    <br/>
                    </Col>
                    </Row>
                    <Row gutter={24}>
                    <Col offset={1}>
                    <p>Dated: <span className='customBold2'>{today8}</span></p>
                    <br/><br/><br/>
                    </Col>
                    </Row>

                    <Row gutter={24}>
                    <Col offset={1} span={6}><p className='borderlineBottom'></p></Col>
                    </Row>

                    <Row gutter={24} >
                    <Col offset={1}>
                    <p>Signature of authorized signatory of joint management body</p>
                    <p>Name : {this.state.setting.nodForm20?this.state.setting.nodForm20.name:''}</p>
                    <p>Designation : {this.state.setting.nodForm20?this.state.setting.nodForm20.designation:''}</p>
                    <p>Note:</p>
                    <p>(1) Not less than two weeks from the date of service of this notice.</p>
                    </Col>
                    </Row>


                    <br/>


                </div>
                ,
                 <div className='pageBreak' />
            ]);
        // } //for loop total page
}
        return table;
}
    }

    render() {
        const loading       = this.state.loading;
        return (
            <Spin spinning={loading}>
                {this._renderTable()}
            </Spin>
        );
      }
  }

class IndexTrialBalance extends React.Component {

  constructor(props) {
      super(props);
    }

  componentWillMount(){}

    render() {
      return (
        <Layout>
            <ReactToPrint
                trigger={() =>
                  <Row><Col style={{float:'right' , marginBottom:'5px'}}>
                  <Button type="primary">Print</Button></Col></Row>}
                content={() => this.componentRef}
            />

            
            <ComponentToPrint ref={el => (this.componentRef = el)}
            id={this.props.match.params.id}
            filterAmount={this.props.commons.filterAmount}
            />
            
        </Layout>
      );
    }
  }


function mapStateToProps(state) {
      return {commons: state.commons}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    //updateMode: updateMode
    }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(IndexTrialBalance)));
